// Third-party imports
import $ from 'jquery';

import { showAddToCartPopup } from '../global/header.js';
import { on_sponsorship_added_to_cart } from '../datalayer/data/sponsorship.js';
import { updateCartButtonIndicator } from './updateCartIndicator.js';
import { renameProperties } from './postDonationProduct.js';
// These methods are used to post a product to the cart
// using the data from a multi-form.

export function postSponsorshipToCart(global, form) {
    renameProperties(global);
    postForm(global, form, false);
}

function postForm(global, form, productInCart) {
    // The code below was got from the url below. This is how to post a multipart
    // form without navigating to the page
    // https://www.mkyong.com/jquery/jquery-ajax-submit-a-multipart-form/

    // Create an FormData object
    let data = new FormData(form);
    $.ajax({
        type: 'POST',
        enctype: 'multipart/form-data',
        url: '/cart/add',
        dataType: 'json',
        data: data,
        processData: false,
        contentType: false,
        cache: false,
        timeout: 5000,
        success: () => {
            // If the item was/is in the cart, we show
            // the popup as an update instead of an add
            showAddToCartPopup(global, productInCart);

            updateCartButtonIndicator();

            on_sponsorship_added_to_cart(global, global.utag_data);
        },
        error: e => {
            let err = {
                msg: 'POST failed for adding item to cart',
                data: e,
            };
            throw err;
        },
    });
}
